export function sendRepresentmentSuccessEvent() {
    try {
        const dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'representment-success'
        })
    } catch (e) { }
}

export function sendRepresentmentErrorEvent() {
    try {
        const dataLayer = window.dataLayer || [];
        dataLayer.push({
            event: 'representment-success'
        })
    } catch (e) { }
}